module.exports = __webpack_public_path__ + "static/media/bot-arrow.f2b1bbe5.svg";